var inputGroup = {
  options: {
    // global options
  },

  selectors: {
    input_group: ".input-group",
    input: ".input-group input, .input-group textarea",
    text_label: ".input-group .input-group__text-label",
    select: ".input-group select",
    selected_value: ".input-group__selected-value",
  },

  init: function () {
    const self = this;

    self.loadFunctionInside();
  },

  loadFunctionInside: function () {
    const self = this;

    //select
    jQuery(self.selectors.select).each(function (index) {
      //init for all elements
      self.setSelectedValue(this);
    });
    jQuery(document).on("change", self.selectors.select, function () {
      //bind input event
      self.setSelectedValue(this);
    });

    //input (init empty)
    jQuery(self.selectors.input).each(function (index) {
      //init for all elements
      self.setEmptyClass(this);
    });
    jQuery(document).on("input", self.selectors.input, function () {
      //bind input event
      self.setEmptyClass(this);
    });

    //input:password
    jQuery(document).on("input", self.selectors.input + "[type='password']", function () {
      //show validation message immediately on password inputs
      jQuery(this)[0].reportValidity();
    });
  },

  setSelectedValue: function (el_select) {
    const self = this;

    let current_selected_value = jQuery(el_select).val();
    if (current_selected_value === null) current_selected_value = ''; //empty

    let current_selected_value_name = jQuery(el_select).children("[value='" + current_selected_value + "']").text();
    if (current_selected_value_name == "") current_selected_value_name = current_selected_value; //not inner text set, set select value instead
    jQuery(el_select).siblings(self.selectors.selected_value).text(current_selected_value_name);
  },

  setEmptyClass: function (el_input) {
    const self = this;

    const el_jquery_input = jQuery(el_input);

    const el_text_label = el_jquery_input.siblings(self.selectors.text_label);
    if (el_text_label.length > 0) {
      if (el_jquery_input.val() == "") {
        el_jquery_input.parent(self.selectors.input_group).addClass("input-group--is-empty");
      } else {
        el_jquery_input.parent(self.selectors.input_group).removeClass("input-group--is-empty");
      }
    }
  }
}

// Export
export { inputGroup };